import { getProductGTMClass } from '$services/storefronts/storefronts'

const platforms = {
    nintendo: 'nintendo',
    microsoft: 'xbox',
    sony: 'playstation',
    steam: 'steam',
    apple: 'apple',
    amazon: 'amazon',
    epic: 'epic',
    humble: 'humble'
}

export function storefrontLinkWithUTMParams(url: string, slug: string, platform: string, utmMedium: string): string {
    const productAbbreviation = capitalize(getProductGTMClass(slug))
    const platformCampaign = capitalize(platforms[platform] as string)

    const trackedUrl = new URL(url)

    if (!trackedUrl.searchParams.has('utm_source')) {
        trackedUrl.searchParams.set('utm_source', 'JBG-Site')
    }

    if (!trackedUrl.searchParams.has('utm_medium')) {
        trackedUrl.searchParams.set('utm_medium', utmMedium)
    }

    if (!trackedUrl.searchParams.has('utm_campaign')) {
        trackedUrl.searchParams.set('utm_campaign', `${productAbbreviation}-${platformCampaign}`)
    }

    return trackedUrl.href
}

export function getPlatformClass(platform: string) {
    return platforms[platform]
}

function capitalize(s: string): string {
    return String(s).charAt(0).toUpperCase() + String(s).slice(1)
}

export function combineUtmParams(destinationUrl: URL, referringParams: URLSearchParams): URL {
    referringParams.forEach((value, key) => {
        if (key.startsWith('utm_')) {
            destinationUrl.searchParams.set(key, value)
        }
    })

    return destinationUrl
}
